import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=48587762&scoped=true&"
import script from "./Comprehensive.vue?vue&type=script&lang=js&"
export * from "./Comprehensive.vue?vue&type=script&lang=js&"
import style0 from "./Comprehensive.vue?vue&type=style&index=0&id=48587762&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48587762",
  null
  
)

export default component.exports